export default __webpack_public_path__ + "static/media/live-icon-active.4dbc981d.webp";